import { ChangeDetectionStrategy, Component, Input, signal, inject } from '@angular/core';
import { IBusinessData, IdCard } from '@mwe/models';
import { EnvironmentService } from '@mwe/services';
import { BasicCardComponent } from '../../cards/basic-card/basic-card.component';
import { TranslateDirective } from '@ngx-translate/core';

@Component({
  changeDetection: ChangeDetectionStrategy.OnPush,
  selector: 'mwe-personal-data-summary-card',
  templateUrl: './personal-data-summary-card.component.html',
  imports: [BasicCardComponent, TranslateDirective],
})
export class PersonalDataSummaryCardComponent {
  protected environmentService = inject(EnvironmentService);

  @Input() isKundeWerden = false;

  @Input() salutation: string;
  @Input() title: string;
  @Input() firstname: string;
  @Input() lastname: string;
  @Input() email: string;
  @Input() birthDate: string;
  @Input() telefonNumber: string;
  @Input() idCard: IdCard;
  @Input() businessData: IBusinessData;

  customerDataType = signal<string | undefined>('Privatkunde');

  constructor() {
    // TODO refactor this whole getPortalCustomerType() stuff. Too much magic strings and too much logic decentralized
    this.customerDataType.set(this.environmentService.getPortalCustomerType() === 'business' ? 'Businesskunde' : 'Privatkunde');
  }
}
